import React from 'react';

class ProjectList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount = () => {
    }

    render() {
        return (
            <>
              Project
            </>
        )
    }
}

export default ProjectList;

